import React from 'react'
import { useTranslation } from 'react-i18next'

import type { DashboardLabTestEntry } from '~/api/graphql/generated/types'

import { useRightRailOverlay } from '../../context/RightRailOverlayContext'
import LabTestDetailsOverlay from './LabTestDetailsOverlay'

import styles from './LabNameCell.module.scss'

interface LabNameCellProps {
  item: DashboardLabTestEntry
}

const LabNameCell = ({ item }: LabNameCellProps) => {
  const { openOverlay } = useRightRailOverlay()
  const { t } = useTranslation('LabTests')

  const handleLabNameClick = () => {
    const overlayContent = <LabTestDetailsOverlay labTest={item} />
    openOverlay(overlayContent)
  }

  return (
    <div className={styles.labNameContainer}>
      {item.testLogs?.map((entry) => (
        <button
          aria-label={t('OPEN_LAB_DETAILS', { labName: entry.name })}
          className={styles.labNameButton}
          key={entry.id}
          title={t('OPEN_LAB_DETAILS', { labName: entry.name })}
          type="button"
          onClick={handleLabNameClick}
        >
          {entry.name}
        </button>
      ))}
    </div>
  )
}

export default LabNameCell
